module.exports = __webpack_public_path__ + "img/banner_fwsrz.ae85e4cd.png";